import type { Binding } from "@/app/types";
import {
  createResourceKeys,
  type PartialOrgProjectScope,
} from "@/lib/resource-context";

type ServerSubKeyParams = {
  serverId: string;
  binding: Binding;
  scope: PartialOrgProjectScope;
};

export const serversKeys = {
  ...createResourceKeys("servers"),

  health: ({ serverId, binding, scope }: ServerSubKeyParams) =>
    [
      "servers",
      "health",
      scope.organizationId,
      scope.projectId,
      binding,
      serverId,
    ] as const,

  serverTools: ({ serverId, binding, scope }: ServerSubKeyParams) =>
    [
      "server-tools",
      scope.organizationId,
      scope.projectId,
      binding,
      serverId,
    ] as const,

  deploymentStatus: ({ serverId, binding, scope }: ServerSubKeyParams) =>
    [
      "servers",
      "deployment-status",
      scope.organizationId,
      scope.projectId,
      binding,
      serverId,
    ] as const,
};
